import FacebookLoader from './../jquery-facebook-sdk/facebook-loader.jquery.js';
import template from 'js/plugin/jquery-featured-post/featured-post.jquery.hbs';

;(function($, window, document, undefined) {
	const pluginName = 'featuredPost';

	class FeaturedPost {
		constructor(element, options) {
			this._name = pluginName;
			this._defaults = $.fn[pluginName].defaults;

			this.element = element;
			this.settings = $.extend(true, this._defaults, options);

			this.init();
		}

		init() {
			this.loader = new FacebookLoader(2);
			this.cacheElements();

			this.$element.prepend(this.loader.$element);

			this.fetchPosts();
		}

		cacheElements() {
			this.$element = $(this.element);
		}

		fetchPosts() {
			let self = this;

			$.get(self.settings.url, function(data) {
				data.map(function(post) {
					// Fix single quote JSON problem
					post.title = post.title.replace(/\&\#39\;/g, '\'');
					post.lead = post.lead.replace(/\&\#39\;/g, '\'');
				});

				let post = data[0];
				let postUrl = new URL(post.url);

				if (postUrl.pathname === location.pathname) {
					post = data[1];
				}

				self.$element.html(self.settings.template(post));

				$(document).trigger('featuredPost:loaded');
			}, "json");
		}
	}

	$.fn[pluginName] = function(options) {
		return this.each(function() {
			if (!$.data(this, 'plugin_${pluginName}')) {
				$.data(this, 'plugin_${pluginName}', new FeaturedPost(this, options));
			}
		});
	};

	$.fn[pluginName].defaults = {
		url: '/noticias/destaque-principal',
		template: template
	};

})(jQuery, window, document);